var render = function render(){var _vm=this,_c=_vm._self._c;return _c('WrappedForm',{ref:"form",staticClass:"education-editor",attrs:{"labelWidth":"150px","model":_vm.educationData,"formLines":_vm.formLines}})
}
var staticRenderFns = []

export { render, staticRenderFns }